import React from 'react';
import {connect} from 'react-redux';
import ShareViaEmail from './ShareViaEmail.jsx';
import {sendResultsViaEmail} from '@ignitesales/neuro-application/src/actions/social-action-creators.mjs';
import {actionCompleted, actionStarted} from '@ignitesales/neuro-application/src/actions/question-action-creators.mjs';
import getLogger from '@ignitesales/logger-es';

const logger = getLogger({component: 'ShareViaEmail'});

const ConnectedShareViaEmail = props => {
  const {
    hasBeenClicked,
    actionStarted,
    actionCompleted,
    sendEmail,
    employee,
    fromEmail,
    ccEmployee = false,
    ...rest
  } = props;

  if(hasBeenClicked){
    actionStarted();
  }

  const sendTheEmail = email => {
    actionCompleted();
    try {
      sendEmail({email, employee, ccEmployee, fromEmail});
    } catch(e) {
      logger.error('An error occurred while sending email', {email, employee, ccEmployee},e );
    }
  };

  return  <ShareViaEmail {...rest} sendEmail={sendTheEmail} />;
};

export default connect(
  ({
    user: {
      assignment: {
        employee
      } = {}
    } = {}
  }) => {

    return {
      employee
    };
  }, dispatch => {
    return {
      sendEmail: ({email, employee, ccEmployee, fromEmail}) => {
        const message = {
          email,
          fromEmail,
          copyMe: employee && ccEmployee
        };
        if (employee && !fromEmail) {
          message.fromEmail = employee.email;
        }
        dispatch(sendResultsViaEmail(message));
      },
      actionStarted: () => {
        dispatch(actionStarted({actionName: 'shareViaEmailClicked'}));
      },
      actionCompleted: () => {
        dispatch(actionCompleted({actionName: 'shareViaEmailClicked'}));
      },
    };
  })(ConnectedShareViaEmail);
